import { css } from '@emotion/css'
import { colors, spacing, fontWeight, shorthandHelper } from '@offerzen/pinata-shame'

const styles = {
  wrapper: css({
    width: '100%',
    backgroundColor: colors.athensGray,
    padding: shorthandHelper([spacing.default, spacing.medium]),
    fontWeight: fontWeight.semiBold,
  }),

  optionalText: css({
    fontWeight: fontWeight.regular,
  }),
}

export default styles
